export default __webpack_public_path__ + "static/media/yellow_pressed.81aa710c.png";